const ISTEST = process.env.VUE_APP_CURRENTMODE === 'test'
const HOSTURL = ISTEST ? 'https://kejibao.dev.qooroo.cn/ykconsole' : 'https://ms.gdkjb.com'

export default HOSTURL
